//Paquetes NFPM de GYF. 
import { Mediator } from 'com-gyf-webcore-mediator';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const GET_REPORTES = 'GET_REPORTES';
export const SET_USER_FUNCTIONS_REPORTS = 'SET_USER_FUNCTIONS_REPORTS';
export const GET_REPORTES_RESULT = 'GET_REPORTES_RESULT';
export const INITIAL_STATE_REPORTS = 'INITIAL_STATE_REPORTS';

/**
 * Obtiene funciones de seguridad.
 * @param {any} currentScope
 */
export function getScreenData( currentScope, login, adUserGroup ) {
    LogHelper.In( getScreenData.name, currentScope, login, adUserGroup );
    return ( dispatch, getState ) => {

        dispatch( { type: GET_REPORTES } );

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }
        LogHelper.Out( getScreenData.name, currentScope, login );
        ConciergeProxy.Execute( ( data ) => getFunctionsCallback( data, currentScope.ProductCode.toUpperCase(), login, adUserGroup, dispatch ), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD" );
    }
}

/**
 * Vuelve el estado de la pantalla al inicial de la misma.
 */
export function resetStateReports() {
    LogHelper.In( resetStateReports.name );

    return ( dispatch ) => {
        dispatch( { type: INITIAL_STATE_REPORTS } );
    }
}

/* -------------------------------------------------------------------------------------- */

/**
 * Action que obtiene los reportes.
 * @param {any} data
 * @param {any} producto
 * @param {any} login
 * @param {any} dispatch
 */
function getFunctionsCallback( data, producto, login, adUserGroup, dispatch ) {
    LogHelper.In(getFunctionsCallback.name, data, producto, login, adUserGroup, dispatch);

    let j = 0
    if ( adUserGroup != "" ) {

        var GroupArray = JSON.parse( adUserGroup );
        GroupArray.push( login );

        for ( var i = 0; i < GroupArray.length; i++ ) {
            let functions = ( data && data.REPORTES ) ? data.REPORTES : [];
            functions.forEach( p => { functions[p.Codigo_Funcion] = true; } );

            dispatch( { type: SET_USER_FUNCTIONS_REPORTS, functions } );

            if ( functions.Consulta == true ) {
                const params = {
                    'Login': GroupArray[i],
                    'Producto': "/" + producto
                };
                Engine1Proxy.AddDataSourcesRequests( params, 'GET_REPORTES', 'Get', 'Concierge', 'Reportes', 1, 'Product', true, 'GET_REPORTES_' + j );
                LogHelper.Out( getFunctionsCallback.name, 'GET_REPORTES_' + j, params );
                j++;
            }

        }
        Engine1Proxy.Execute( ( data ) => loadReportes( dispatch, data ) );

    } else {

        let functions = ( data && data.REPORTES ) ? data.REPORTES : [];
        functions.forEach( p => { functions[p.Codigo_Funcion] = true; } );

        dispatch( { type: SET_USER_FUNCTIONS_REPORTS, functions } );

        if ( functions.Consulta == true ) {
            const params = {
                'Login': login,
                'Producto': "/" + producto
            };

            Engine1Proxy.AddDataSourcesRequests( params, 'GET_REPORTES', 'Get', 'Concierge', 'Reportes', 1, 'Product', true, 'GET_REPORTES_' + j );

            LogHelper.Out( getFunctionsCallback.name, 'GET_REPORTES', params );
            Engine1Proxy.Execute( ( data ) => loadReportes( dispatch, data ) );
        }
    }
}

/**
 * Carga los reportes
 * @param {any} dispatch
 * @param {any} data
 */
function loadReportes( dispatch, data ) {
    LogHelper.In( loadReportes.name, dispatch, data );

    let reportesObtenidos = [];
    let i = 0;
    while ( data.hasOwnProperty( 'GET_REPORTES_' + i ) ) {
        let resultadoBusqueda = JSON.parse( data['GET_REPORTES_' + i] ).Recordset0.Rows;
        if ( resultadoBusqueda !== undefined )
            for ( var j = 0; j < resultadoBusqueda.length; j++ ) {
                if ( reportesObtenidos.filter( item => item.ItemId == resultadoBusqueda[j].ItemId ) == 0 ) {
                    reportesObtenidos.push( resultadoBusqueda[j] );
                }

            }
        i++;
    }
    var parsedData = reportesObtenidos;

    if ( parsedData.length > 0 ) {
        Object.defineProperty( Array.prototype, 'group', {
            configurable: true,
            enumerable: false,
            value: function ( key ) {
                var map = {};
                this.forEach( function ( e ) {
                    var k = key( e );
                    map[k] = map[k] || [];
                    map[k].push( e );
                } );
                return Object.keys( map ).map( function ( k ) {
                    return { key: k, data: map[k] };
                } );
            }
        } );

        parsedData = ValidatePath( parsedData );

        const mappedData = parsedData.map( p => { p.grupo = p.path.split( '/' )[2]; return p } );
        const groupedData = mappedData.group( function ( item ) {
            return item.grupo;
        } );

        LogHelper.Out( loadReportes.name, groupedData );
        dispatch( { type: GET_REPORTES_RESULT, data: groupedData } );
    }
    else {
        LogHelper.Out( loadReportes.name );
        dispatch( { type: GET_REPORTES_RESULT, data: [] } );
    }
}

/**
 * Valida que el no se repitan en el PATH datos de la URL.
 * @param {any} parsedData
 */
function ValidatePath( parsedData ) {
    var data = parsedData;
    const splitUrl = reportesUrl.split( "ItemPath=" );

    if ( splitUrl[1] ) {
        const endIndex = splitUrl[1].length;

        data = parsedData.filter( p => {
            if ( p.path.search( splitUrl[1] ) > -1 ) {
                if ( endIndex > 0 ) {
                    p.path = p.path.replace( p.path.substring( 0, endIndex ), "" );
                    return p;
                }
            }
        } );
    }

    return data;
}


// WEBPACK FOOTER //
// ./Portico/App/Screens/InvocadorReportes/actions/Actions.js